module.exports = __webpack_public_path__ + "media/images/promo/championship/Scoreboard_PNG-ccb573e2717585c1ab0f305d9c2d8778.png";